export const REGISTER_SERVICE_ACCOUNT_NAME = "register_service_account";

export const REGISTER_SERVICE_ACCOUNT_DESC = `Registers a service account for the current workspace (e.g., for Search Console access).

Use this tool when a user wants to add a service account under Settings -> Service accounts.

This tool opens a UI to upload a Service Account JSON key file and register it for the current workspace.
Notes:
- Do not repeat the UI instructions in your chat message. Prefer calling the tool directly (the confirmation UI contains the steps).
- Write operation. User confirmation required.
- The JSON key is sensitive. Prefer uploading the file via the UI (do not paste secrets into chat).`;
